angular.module('jv.cand.details.talent.fit.directive', [])
.directive('candidateTalentFit', ['i18n', function(i18n) {
    return {
        restrict: 'A',
        scope: {
            positives: '=ngModel',
            jobtitle: '=jobtitle'
        },
        templateUrl: '/jhire/htm/common/talentFit.html',
        link: function(scope, element) {
            scope.isCandidateRankingEnabled = window.properties.isCandidateRankingEnabled === 'True';
            scope.enableTalentFit = window.properties.enableTalentFit === 'True';
            scope.i18n = i18n;

            scope.evaluationPositives = [];
            scope.evaluationNegatives = [];
            scope.areasToClarify = [];
            scope.finalRecommendation  = '';

            scope.showProcessingMessage = function() {
                const talentFitSummary = element[0].querySelector('.candidate-talent-fit-summary');
                const processingMessage = element[0].querySelector('.processing-message');


                if (talentFitSummary && processingMessage) {
                    if (scope.positivesStatus === 'pending') {
                        talentFitSummary.classList.add('blurred');
                        processingMessage.style.display = 'block';
                    } else {
                        talentFitSummary.classList.remove('blurred'); // Remove if status is not pending
                        processingMessage.style.display = 'none';
                    }
                }
            };

            scope.$watch('positives', function(newVal) {
                if (newVal) {
                    scope.positivesStatus = newVal || '';
                }
                if (newVal && newVal.evaluationSummary) {
                    scope.evaluationPositives = newVal.evaluationSummary.positives || [];
                    scope.evaluationNegatives = newVal.evaluationSummary.negatives || [];
                    scope.areasToClarify = newVal.evaluationSummary.areasToClarify || [];
                    scope.finalRecommendation = newVal.evaluationSummary.finalRecommendation || '';
                }
                scope.showProcessingMessage();

            });

            scope.showSeeMoreTalentDetailsModal = false;

            scope.handleSeeMoreTalentDetails = function () {
                scope.showSeeMoreTalentDetailsModal = true;
            };

            scope.closeSeeMoreTalentDetails = function () {
                scope.showSeeMoreTalentDetailsModal = false;
            };
        }
    };
}]);
